var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.54795 1.18839L1.84932 3.32538C1.32877 3.51716 1 4.01031 1 4.55826V10.7226C1 11.2158 1.27397 11.6815 1.71233 11.9007L7.41096 14.75C7.79452 14.9418 8.20548 14.9418 8.58904 14.75L14.2877 11.9007C14.726 11.6815 15 11.2158 15 10.7226V4.55826C15 4.01031 14.6712 3.51716 14.1507 3.32538L8.45206 1.18839C8.17808 1.0788 7.84931 1.0788 7.54795 1.18839ZM8.0137 2.88702L13.274 4.85963V4.88702L8.0137 7.02401L2.75342 4.88702V4.85963L8.0137 2.88702ZM8.89041 12.6404V8.55826L13.274 6.77743V10.4487L8.89041 12.6404Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/Cube.28a414dbe032afe1156b0a822f536f6b.svg";
export { ForwardRef as ReactComponent };